import { Link } from 'react-router-dom';
import type { LatestUpdateItem } from '../../hooks/useLatestUpdates';

interface LatestUpdateCardProps {
  update: LatestUpdateItem;
}

const isExternalUrl = (url: string) => /^https?:\/\//i.test(url);

export const LatestUpdateCard = ({ update }: LatestUpdateCardProps) => {
  const linkUrl = update.link?.url?.trim();
  const linkText = update.link?.text?.trim() || 'Learn more';

  return (
    <article className="relative h-full origin-center scale-[0.97] rounded-2xl bg-light-green p-4 transition-transform duration-300 ease-out will-change-transform hover:z-10 hover:scale-100">
      <div className="flex h-full flex-col gap-2">
        <h3 className="font-haffer text-sh-20-30 font-bold text-black-200">{update.title}</h3>
        <p className="font-haffersq text-sh-16-24 text-dark-grey">{update.text}</p>
        {linkUrl ? (
          isExternalUrl(linkUrl) ? (
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto font-haffer text-xs font-bold leading-[18px] text-people-teal-600">
              {linkText}
            </a>
          ) : (
            <Link to={linkUrl} className="mt-auto font-haffer text-xs font-bold leading-[18px] text-people-teal-600">
              {linkText}
            </Link>
          )
        ) : null}
      </div>
    </article>
  );
};
